import Styled from 'styled-components';

export type VALID_DATAPOINT_SIZE = 'small' | 'large';

export interface IDatapointProps {
  size?: VALID_DATAPOINT_SIZE;
  weight?: 'normal' | 'bold';
}

const DATAPOINT_SIZE_MAP: { [key in VALID_DATAPOINT_SIZE]: string } = {
  small: '2.4rem',
  large: '4.2rem'
};
const DATAPOINT_LINE_HEIGHT_MAP: { [key in VALID_DATAPOINT_SIZE]: string } = {
  small: '3.2rem',
  large: '5.2rem'
};

// replace createElement in styled-components v4 with 'as'
export const Datapoint = Styled.span<IDatapointProps>`
  font-size: ${({ size }) => DATAPOINT_SIZE_MAP[size || 'large']};
  line-height: ${({ size }) => DATAPOINT_LINE_HEIGHT_MAP[size || 'large']};
  font-weight: ${({ theme: { label }, weight }) => weight || label.datapointWeight};
`;

Datapoint.defaultProps = {
  size: 'large',
};

Datapoint.displayName = 'Datapoint';
